import { Howl, Howler } from 'howler'
import * as React from 'react'
import { withPrefix } from 'gatsby'

import { BgmType } from '../recoil/atoms/appAtom'
import { useRecoilBgm } from './useRecoilBgm'
import { useRecoilSound } from './useRecoilSound'

const masterVolume = 0.5
const fadeIn = (sound?: Howl) => {
  return new Promise((resolve) => {
    if (sound) {
      sound.off()
      sound.once('fade', () => {
        resolve()
      })
      sound.play()
      sound.fade(0, masterVolume, 500)
    } else {
      resolve()
    }
  })
}

const fadeOut = (sound?: Howl) => {
  return new Promise((resolve) => {
    if (sound) {
      sound.off()
      sound.once('fade', () => {
        sound.stop()
        resolve()
      })
      sound.fade(masterVolume, 0, 500)
    } else {
      resolve()
    }
  })
}

interface BgmHowl {
  normal: Howl | null
}

export const fftSize = 256

export const useBgm = () => {
  const { sound } = useRecoilSound()
  const { bgm, setBgm } = useRecoilBgm()

  const [bgmHowl, setBgmHowl] = React.useState<BgmHowl>({ normal: null })
  const [analyser, setAnalyser] = React.useState<AnalyserNode | null>(null)

  const getBgmSound = (type: BgmType) => {
    switch (type) {
      case 'normal':
        if (bgmHowl.normal) {
          return bgmHowl.normal
        } else {
          const howl = new Howl({
            src: [withPrefix('/sounds/bgm.mp3')],
            loop: true,
          })

          if (analyser === null) {
            const an = Howler.ctx.createAnalyser()

            // ボリュームコントローラ
            // Howler.ctx.createGain = Howler.ctx.createGain || Howler.ctx.createGainNode
            const volume = 0.5
            const gainNode = Howler.ctx.createGain()
            gainNode.gain.setValueAtTime(volume, Howler.ctx.currentTime)

            Howler.masterGain.connect(an)
            an.connect(gainNode)
            gainNode.connect(Howler.ctx.destination)

            an.fftSize = fftSize
            setAnalyser(an)
          }

          setBgmHowl({
            ...bgmHowl,
            normal: howl,
          })
          return howl
        }
        break
      default:
        return undefined
        break
    }
  }

  React.useEffect(async () => {
    if (sound) {
      const prev = getBgmSound(bgm.prev)
      const now = getBgmSound(bgm.current)
      await fadeOut(prev)
      await fadeIn(now)
    }
  }, [bgm])

  React.useEffect(async () => {
    const now = getBgmSound(bgm.current)
    if (sound) {
      await fadeIn(now)
    } else {
      await fadeOut(now)
    }
  }, [sound])

  const playBgm = (type: BgmType) => {
    setBgm({ prev: bgm.current, current: type })
  }

  return {
    playBgm: playBgm,
    analyser: analyser,
  }
}
